import { applyMiddleware, compose, createStore } from "redux";
import { createEpicMiddleware } from "redux-observable";

import { rootEpic } from "./epics";
import { rootReducer } from "./reducers";

const epicMiddleware = createEpicMiddleware();

let enhancer;
if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { composeWithDevTools } = require("redux-devtools-extension");
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { createLogger } = require("redux-logger");

    enhancer = composeWithDevTools(applyMiddleware(createLogger(), epicMiddleware));
} else {
    enhancer = compose(applyMiddleware(epicMiddleware));
}

const store = createStore(rootReducer, enhancer);

epicMiddleware.run(rootEpic);

export default store;
